import React, { useState, useEffect } from 'react'
import { Button, Select, Spin } from 'antd'
import { useNavigate } from 'react-router-dom'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

function AddStarterActivities() {
  const navigate = useNavigate()

  const [allRequestCompleted, setAllRequestCompleted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingTwo, setLoadingTwo] = useState(false)
  const [focusItems, setFocusItems] = useState([])
  const [selected, setSelected] = useState([])
  const [organizations, setOrganizations] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')

  // All all focus items from all clubs
  const getFocusItems = async (org) => {
    try {
      setLoadingTwo(true)

      let query = `/api/v1/focus/focusItems`

      const response = await axiosInstance.get(query)

      // console.log(response.data)
      setFocusItems(response.data?.focusItems)

      getStoreStarterActivities(org) // To prefil default selection if anything stored before

      setLoadingTwo(false)
    } catch (e) {
      console.log(e)
      setLoadingTwo(false)
    }
  }

  const storeStarterActivities = async () => {
    try {
      setLoadingTwo(true)

      const response = await axiosInstance.post(`/api/v1/search/storeStarterActivities?organization=${selectedOrg}`, {
        selected,
      })

      setLoadingTwo(false)

      alert('Success')
    } catch (e) {
      console.log(e)
      setLoadingTwo(false)
    }
  }

  const getStoreStarterActivities = async (org) => {
    try {
      setLoadingTwo(true)
      setAllRequestCompleted(false)

      const response = await axiosInstance.get(`/api/v1/search/getStarterActivities?organization=${org || selectedOrg}`)
      const theIds = response.data?.searchResults?.map((el) => el._id)

      setSelected(theIds)
      setAllRequestCompleted(true)

      setLoadingTwo(false)
    } catch (e) {
      console.log(e)
      setLoadingTwo(false)
    }
  }

  const handleChange = (value) => {
    setSelectedOrg(value)
    getFocusItems(value)
  }

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    getMyInfo()
  }, [])

  return (
    <Layout>
      <Button
        onClick={() => {
          navigate(-1)
        }}
      >
        Back
      </Button>
      <h2>Handle starter activities</h2>

      {loadingTwo && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}

      {organizations.length > 0 && (
        <div>
          <p>Choose organization</p>
          <Select
            placeholder="Please select club or business"
            style={{
              width: 250,
              marginRight: 10,
            }}
            onChange={handleChange}
            options={organizations}
          />
        </div>
      )}

      {allRequestCompleted && (
        <>
          <Select
            mode="multiple"
            optionFilterProp="label"
            placeholder="Mandatory priorities"
            style={{
              width: `100%`,
              marginTop: 10,
            }}
            defaultValue={focusItems
              ?.filter((el) => selected?.some((theId) => theId === el._id))
              .map((el) => {
                return {
                  label: el.subTitle,
                  value: el._id,
                }
              })}
            onChange={(value) => {
              setSelected(value)
            }}
            options={focusItems
              //   .filter((el) => el.category == 'priorities') // No filter needed for now
              .map((el) => {
                return {
                  label: el.subTitle,
                  value: el._id,
                }
              })}
          />

          <br />
          <br />
          <Button
            type="primary"
            onClick={() => {
              storeStarterActivities()
            }}
          >
            Update
          </Button>
        </>
      )}
    </Layout>
  )
}

export default AddStarterActivities
